const TRANSLATED_HTML_CLASSES = ['translated-ltr', 'translated-rtl'];
const TRANSLATED_MARKERS_SELECTOR = 'ya-tr-span, *[_msttexthash], *[x-bergamot-translated]';

export function isTranslatedEnvironmentDetected(): boolean {
  return hasTranslatedDomMarkers();
}

function hasTranslatedDomMarkers(): boolean {
  const html = document.documentElement;
  if (!html) {
    return false;
  }

  if (TRANSLATED_HTML_CLASSES.some((className) => html.classList.contains(className))) {
    return true;
  }

  return !!document.querySelector(TRANSLATED_MARKERS_SELECTOR);
}
